<template>
  <div>
    <div class="login_Head">
      <img style="width: 100%; height: 100%"
           src="../assets/loginImgs/loginHead@2x.png" />
    </div>

    <div class="login_Box">

      <div class="login_Right">
        <div class="text_2" style="color: #2878FF;text-align: center;">用户登录</div>
        <div class="margin58">
          <div style="position: relative">
            <input style="font-family: Regular;"
                   class="userIn"
                   type="text"
                   v-model="userInfo.userName"
                   placeholder="请学员输入账号" />
            <img class="img_box"
                 src="../assets/loginImgs/user_icon@2x.png"
                 alt="" />
          </div>

          <div class="margin25">
            <input style="font-family: Regular;"
                   class="userIn"
                   type="password"
                   v-model="userInfo.userPasswd"
                   placeholder="请学员输入密码" />
            <img class="img_box"
                 src="../assets/loginImgs/psd_icon@2x.png"
                 alt="" />
          </div>

          <el-button @click="login"
                     class="login_btn"
                     style="">立即登录</el-button>
        </div>

        <!-- <div class="bottomBox_a">
          <div>
            忘记密码
          </div>
          <div>
            新用户注册
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { mapMutations } from 'vuex';
import { doLogin } from '../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      userInfo: {
        userName: '', //用户名
        userPasswd: '' //密码
      }, //登录数据
      isFullScreen: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
  },
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    //登录
    login() {
      if (this.userInfo.userName =='' && this.userInfo.userPasswd =='' ) {
        return false
      }
      doLogin(this.userInfo).then(res => {
        ////console.log(res);
        if (res.data.token) {
          this.updateToken(res.data.token);
          //拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);
          //提示成功
          this.$message({
            message: '登录成功!',
            type: 'success'
          });
          this.$router.push({ path: '/' });
        } else {
          //登录失败
          this.$message({
            message: '账号或密码错误!',
            type: 'error'
          });
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.text_6 {
  text-align: center;
  margin-top: 12px;
}
.title {
  font-size: 22px;
  color: #272748;
  text-align: center;
  font-family: bold;
}
.img_1 {
  width: 248px;
  height: 248px;
}
.text_5 {
  margin-top: 8px;
  font-size: 16px;
  color: #272748;
  text-align: center;
  font-family: Regular;
}

.text_2 {
  font-size: 22px;
  color: #272748;
  font-family: bold;
}
.text_1 {
  margin-top: 8px;
  font-size: 14px;
  color: #272748;
  font-family: Regular;
}
.margin25 {
  position: relative;
  margin-top: 25px;
}
.margin58 {
  margin-top:25px;
}
.img_box {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 20px;
  top: 17px;
}
.login_btn {
  font-family: Regular;
  margin-top:30px;
  background: #4275f5;
  border-radius: 12px;
  width: 300px;
  height: 50px;
  color: #fff;
  font-size: 16px;
}
.login_Head {
  width: 100%;
  height: 250px;
}
.login_Box {
  position: absolute;
  top: 155px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 360px;
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(160, 160, 160, 0.16);
  opacity: 1;
  border-radius: 20px;
  display: flex;
  overflow: hidden;
  .login_Left {
    width: 50%;
    background: url('../assets/loginImgs/login_left@2x.png') 100% 100%;
    padding: 50px 0 0 0;
  }
  .login_Right {
    padding:43px 30px;
    .bottomBox_a {
      display: flex;
      justify-content: space-between;
      color: #2878FF;
      font-size: 14px;
      margin-top: 12px;
      div {
        cursor: pointer;
      }
    }
  }
  .userIn {
    padding-left: 48px;
    width: 300px;
    height: 45px;
    background: #f0f3f7;
    opacity: 1;
    border-radius: 12px;
    border: 0;
    font-size: 14px;
  }
}
</style>
